module.exports = __webpack_public_path__ + "img/bottom-dintica.04be5f73.png";